import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-building',
  templateUrl: './building.component.html',
  styleUrls: ['./building.component.scss']
})
export class BuildingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
